/**
 *
 * @module sessionProfileInfo
 *
 */

import Check from 'check-types';
import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

/**
 *
 * @class SessionProfileInfo
 * @desc Represents the session profile info provided by the service.
 *
 */
export default class SessionProfileInfo {

    /**
     *
     * @param {String} id
     *
     */
    constructor(id) {

        const errorMessage = {
            ctor: 'SessionProfileInfo(id)',
            get id() {
                return `${this.ctor} id should be a String with length`;
            }
        };

        Check.assert.nonEmptyString(id, errorMessage.id, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.id = id;

    }

}



// WEBPACK FOOTER //
// ./src/services/session/sessionProfileInfo.js